export default __webpack_public_path__ + "static/media/monCV.3731ac95.png";